<template>
	<!--  -->
	<b-modal
		v-model="isPurchaseModalActive"
		:width="450"
		scroll="keep"
		:destroyOnHide="destroyOnHideValue"
		:canCancel="canCancelValue">
		<div class="card">
			<div class="card-content">
				<div class="content">
					<div
						class="p-5 has-background-white"
						style="border-radius: 6px">
						<div class="columns is-multiline">
							<div class="column pb-2 pt-5 pl-5 pr-5 m-0 is-full">
								<h1 class="has-text-centered has-text-weight-bold">
									Processing
								</h1>
							</div>
							<div class="column is-full p-0">
								<p>
									If your card provider requires you to complete a task
									or verification below, please proceed as directed.
								</p>
								<iframe
									class="iframe"
									:srcdoc="iframe_srcdoc"></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
	<!--  -->
</template>
<style lang="scss" scoped>
	// @import "./../../../../sass/app.scss";
	h1 {
		text-transform: none;
	}

	.iframe {
		height: 55vh;
		width: 100%;
	}

	.iframe[srcdoc=""] {
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;' width='200px' height='200px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'%3E%3Cg transform='rotate(0 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.9411764705882353s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(21.176470588235293 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.8823529411764706s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(42.35294117647059 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.8235294117647058s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(63.529411764705884 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.7647058823529411s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(84.70588235294117 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.7058823529411765s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(105.88235294117646 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.6470588235294118s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(127.05882352941177 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5882352941176471s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(148.23529411764707 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5294117647058824s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(169.41176470588235 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.47058823529411764s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(190.58823529411765 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.4117647058823529s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(211.76470588235293 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.35294117647058826s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(232.94117647058823 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.29411764705882354s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(254.11764705882354 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.23529411764705882s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(275.29411764705884 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.17647058823529413s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(296.47058823529414 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.11764705882352941s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(317.6470588235294 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.058823529411764705s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(338.8235294117647 50 50)'%3E%3Crect x='48' y='23.5' rx='2' ry='5.98' width='4' height='13' fill='%23000000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='0s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3C/svg%3E");
		background-repeat: no-repeat;
		background-position: center;
		background-size: 13rem;
	}
</style>
<script type="text/javascript">
	import Vue from "vue";
	import Buefy from "buefy";
	import axios from "axios";
	axios.defaults.headers.post["X-CSRF-TOKEN"] = window.csrf_token;

	Vue.use(Buefy);
	export default {
		props: ["iframe_srcdoc_prop"],
		components: {},
		data() {
			return {
				isPurchaseModalActive: false,
				canCancelValue: [], // "escape", "outside", "x"
				destroyOnHideValue: false,
			};
		},
		computed: {
			iframe_srcdoc() {
				if (this.$props.iframe_srcdoc_prop) {
					return this.$props.iframe_srcdoc_prop;
				} else {
					return "";
				}
			},
		},
		methods: {
			launchModal(timer) {
				if (typeof timer == "number") {
					setTimeout(() => {
						this.isPurchaseModalActive = true;
					});
					return;
				}
				this.isPurchaseModalActive = true;
			},
			closeModal(timer) {
				if (typeof timer == "number") {
					setTimeout(() => {
						this.isPurchaseModalActive = false;
					});
					return;
				}
				this.isPurchaseModalActive = false;
			},
		},
	};
</script>
